import React from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

function Icon() {
  const isMobile = useIsMobile()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={!isMobile ? "10vw": "36vw"}
      height={!isMobile ? "10vw": "36vw"}
      fill="none"
      viewBox="0 0 174 169"
    >
      <path
        stroke="#575757"
        strokeWidth="2"
        d="M151.25 27.258v1h10.875v10.903H173v107.033h-10.875v10.903H151.25V168H22.75v-10.903H11.875v-10.903H1V39.161h10.875V28.258H22.75V17.355h54.375V1h19.75v16.355h54.375v9.903zm-9.875 66.42h1v-34.71H107.75v34.71h33.625zm-43.5 43.612h1v-12.903h-23.75v12.903h22.75zm-65.25-12.903h-1v12.903H66.25v-12.903H32.625zm0-65.42h-1v34.71H66.25v-34.71H32.625zm75.125 77.323v1h34.625v-12.903H107.75v11.903z"
      ></path>
    </svg>
  );
}

export default Icon;
